import { Component, Input, OnInit } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';

import { SourceGroupService } from '../../services/source-group.service';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { SourceGroup } from '../../models/source-group.model';
import { ChipModel } from '@Common/Forms/models/chip.model';

@Component({
    selector: 'agpr-source-create-dialog',
    templateUrl: './source-create-dialog.component.html',
    styleUrls: ['./source-create-dialog.component.scss'],
    standalone: false
})
export class SourceCreateDialogComponent extends AbstractDialogComponent implements OnInit {
    readonly buttonStyle = ButtonTypesEnum;

    @Input() currentGroup: SourceGroup;

    sourceIds: number[] = [];
    sourceGroups$: Observable<SourceGroup[]>;
    selectedGroups: SourceGroup[] = [];
    groupChips: ChipModel[] = [];

    constructor(
        public coreDialogService: CoreDialogService,
        public localizationService: LocalizationService,
        public sourceGroupService: SourceGroupService
    ) {
        super(coreDialogService, 'SourceCreate');
    }

    ngOnInit(): void {
        this.sourceGroups$ = this.sourceGroupService.all$;
        if (this.currentGroup) {
            this.addGroupChip(this.currentGroup);
        }
    }

    addSources(ids: number[]) {
        this.sourceIds.push(...ids);
    }

    removeSource(id: number) {
        this.sourceIds = this.sourceIds.filter(sourceId => sourceId !== id);
    }

    addGroupChip(group: SourceGroup) {
        this.selectedGroups.push(group);
        this.groupChips.push({
            id: group.id,
            label: group.name
        });
    }

    removeGroupChip(index: number) {
        const chip = this.groupChips.splice(index, 1);
        this.selectedGroups = this.selectedGroups.filter(group => group.id !== chip[0].id);
    }

    done() {
        if (this.selectedGroups.length) {
            const requests: Observable<number>[] = [];
            this.selectedGroups.forEach(group => {
                group.sourceIds.push(...this.sourceIds);
                requests.push(this.sourceGroupService.update(group));
            });
            forkJoin(requests).subscribe({
                next: () => {
                    this.closeDialog();
                }
            });
        } else {
            this.closeDialog();
        }
    }

    cancel() {
        this.closeDialog();
    }
}
